import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTENROLLDETAIL,
  GET_STUDENTENROLLDETAILS,
  GET_STUDENTENROLLDETAILS_BY_FILTER,
  GET_ALL_STUDENT_ENROLL_DETAILS_STAT,
  GET_STUDENTENROLLDETAILS_STAT,
  ADD_STUDENTENROLLDETAILS,
  UPDATE_STUDENTENROLLDETAIL,
  UPDATE_STUDENTENROLLDETAIL_IS_DROP,
  DELETE_STUDENTENROLLDETAIL,
} from '@/queries/modules/student-enroll/student-enroll-detail.js';

export async function getStudentEnrollDetails(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLDETAILS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.studentEnrollDetail;
    } else {
      context.commit('setStudentEnrollDetails', data.getStudentEnrollDetails);
      context.commit('setSuccess', null);
      return data.getStudentEnrollDetails
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getStudentEnrollDetailsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLDETAILS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentEnrollDetails', data.getStudentEnrollDetailsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentEnrollDetailsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentEnrollDetail(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLDETAIL,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return context.state.studentEnrollDetail;
    } else {
      context.commit('setStudentEnrollDetail', data.getStudentEnrollDetail);
      context.commit('setSuccess', null);
      return data.getStudentEnrollDetail
    }

  } catch (e) {
    context.commit('setError', error(e));
    return {status: {success: false, error: true, message: "", full: e}};
  }
}

export async function getAllStudentEnrollDetailsStat(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ALL_STUDENT_ENROLL_DETAILS_STAT,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getAllStudentEnrollDetailsStat
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getStudentEnrollDetailsStat(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLDETAILS_STAT,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getStudentEnrollDetailsStat;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addStudentEnrollDetails(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTENROLLDETAILS,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentEnrollDetails = [...context.state.studentEnrollDetails];
      studentEnrollDetails.push(data.addStudentEnrollDetails);
      context.commit('setStudentEnrollDetails', studentEnrollDetails);
      context.commit('setSuccess', newItemSuccess(data.addStudentEnrollDetails.subjectCode));

      return data.addStudentEnrollDetails
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentEnrollDetail(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTENROLLDETAIL,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentEnrollDetails.findIndex(item => item.id === data.updateStudentEnrollDetail.id);
      const studentEnrollDetails = [
        ...context.state.studentEnrollDetails.slice(0, index),
        data.updateStudentEnrollDetail,
        ...context.state.studentEnrollDetails.slice(index + 1)
      ];
      context.commit('setStudentEnrollDetails', studentEnrollDetails);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentEnrollDetail.subjectCode));

      return data.updateStudentEnrollDetail
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentEnrollDetailIsDrop(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTENROLLDETAIL_IS_DROP,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentEnrollDetails.findIndex(item => item.id === data.updateStudentEnrollDetailIsDrop.id);
      const studentEnrollDetails = [
        ...context.state.studentEnrollDetails.slice(0, index),
        data.updateStudentEnrollDetailIsDrop,
        ...context.state.studentEnrollDetails.slice(index + 1)
      ];
      context.commit('setStudentEnrollDetails', studentEnrollDetails);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentEnrollDetailIsDrop.subjectCode));

      return data.updateStudentEnrollDetailIsDrop
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudentEnrollDetail(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENTENROLLDETAIL,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.studentEnrollDetails.findIndex(item => item.id === data.deleteStudentEnrollDetail.id);
      const studentEnrollDetails = [
        ...context.state.studentEnrollDetails.slice(0, index),
        ...context.state.studentEnrollDetails.slice(index + 1)
      ];
      context.commit('setStudentEnrollDetails', studentEnrollDetails);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudentEnrollDetail.subjectCode));

      return data.deleteStudentEnrollDetail
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}



